// import React, { useState } from 'react';
// import { useLocation, useNavigate } from 'react-router-dom';
// import { resetPassword, forgotPassword } from '../../services/api';

// const ResetPasswordWithOtp = () => {
//   const { state } = useLocation();
//   const navigate = useNavigate();
//   const email = state?.email;

//   const [otp, setOtp] = useState('');
//   const [password, setPassword] = useState('');
//   const [message, setMessage] = useState('');
//   const [resendMessage, setResendMessage] = useState('');

//   const handleReset = async (e) => {
//     e.preventDefault();
//     setMessage('');
//     try {
//       const response = await resetPassword(email, password, otp);
//       setMessage(response.data.message || 'Password reset successful!');
//       navigate('/');
//     } catch (error) {
//       setMessage(error.response?.data?.message || 'Failed to reset password');
//     }
//   };

//   const handleResend = async () => {
//     setResendMessage('');
//     try {
//       const response = await forgotPassword(email);
//       setResendMessage(response.data.message || 'OTP resent!');
//     } catch (error) {
//       setResendMessage(error.response?.data?.message || 'Failed to resend OTP');
//     }
//   };

//   if (!email) return <p className="text-center mt-10">Email not found. Please restart the process.</p>;

//   return (
//     <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
//       <div className="bg-white shadow-md rounded-lg p-8 max-w-md w-full">
//         <h2 className="text-2xl font-semibold text-center mb-6">Reset Password</h2>
//         <form onSubmit={handleReset} className="space-y-4">
//           <input
//             type="email"
//             value={email}
//             readOnly
//             className="w-full bg-gray-100 border border-gray-300 px-4 py-2 rounded-md"
//           />
//           <input
//             type="text"
//             placeholder="Enter OTP"
//             value={otp}
//             onChange={(e) => setOtp(e.target.value)}
//             className="w-full border border-gray-300 px-4 py-2 rounded-md"
//             required
//           />
//           <input
//             type="password"
//             placeholder="Enter New Password"
//             value={password}
//             onChange={(e) => setPassword(e.target.value)}
//             className="w-full border border-gray-300 px-4 py-2 rounded-md"
//             required
//           />
//           <button type="submit" className="w-full bg-green-600 text-white py-2 rounded-md hover:bg-green-700">
//             Reset Password
//           </button>
//         </form>

//         <div className="mt-4 text-center">
//           <button onClick={handleResend} className="text-blue-600 hover:underline">
//             Resend OTP
//           </button>
//           {resendMessage && <p className="text-sm mt-2 text-green-600">{resendMessage}</p>}
//         </div>

//         {message && <p className="mt-4 text-center text-red-600">{message}</p>}
//       </div>
//     </div>
//   );
// };

// export default ResetPasswordWithOtp;

import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { resetPassword, forgotPassword } from '../../services/api';

const ResetPasswordWithOtp = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const email = state?.email;

  const [otp, setOtp] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [message, setMessage] = useState('');
  const [resendMessage, setResendMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [resending, setResending] = useState(false);

  const handleReset = async (e) => {
    e.preventDefault();
    setMessage('');
    setLoading(true);
    try {
      const response = await resetPassword(email, password, otp);
      setMessage(response.data.message || 'Password reset successful!');
      setTimeout(() => navigate('/'), 1200);
    } catch (error) {
      setMessage(error.response?.data?.message || 'Failed to reset password');
    } finally {
      setLoading(false);
    }
  };

  const handleResend = async () => {
    setResendMessage('');
    setResending(true);
    try {
      const response = await forgotPassword(email);
      setResendMessage(response.data.message || 'OTP resent!');
    } catch (error) {
      setResendMessage(error.response?.data?.message || 'Failed to resend OTP');
    } finally {
      setResending(false);
    }
  };

  if (!email) {
    return (
      <p className="text-center mt-10">
        Email not found. Please restart the process.
      </p>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
      <div className="bg-white shadow-md rounded-lg p-8 max-w-md w-full">
        <h2 className="text-2xl font-semibold text-center mb-6">Reset Password</h2>

        <form onSubmit={handleReset} className="space-y-4">
          <input
            type="email"
            value={email}
            readOnly
            className="w-full bg-gray-100 border border-gray-300 px-4 py-2 rounded-md"
          />

          <input
            type="text"
            placeholder="Enter OTP"
            value={otp}
            onChange={(e) => {
              const val = e.target.value.replace(/\D/g, '');
              if (val.length <= 4) setOtp(val);
            }}
            className="w-full border border-gray-300 px-4 py-2 rounded-md"
            required
            inputMode="numeric"
            pattern="[0-9]*"
          />

          {/* ✅ Password input with eye toggle */}
          <div className="relative">
            <input
              type={showPassword ? 'text' : 'password'}
              placeholder="Enter New Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full border border-gray-300 px-4 py-2 pr-12 rounded-md"
              required
            />
            <button
              type="button"
              onClick={() => setShowPassword((prev) => !prev)}
              className="absolute inset-y-0 right-0 px-3 flex items-center text-gray-500 hover:text-gray-700 focus:outline-none"
              aria-label={showPassword ? 'Hide password' : 'Show password'}
              tabIndex={-1}
            >
              {showPassword ? <EyeOffIcon /> : <EyeIcon />}
            </button>
          </div>

          <button
            type="submit"
            disabled={loading}
            className={`w-full bg-green-600 text-white py-2 rounded-md hover:bg-green-700 ${
              loading ? 'opacity-60 cursor-not-allowed' : ''
            }`}
          >
            {loading ? 'Resetting...' : 'Reset Password'}
          </button>
        </form>

        <div className="mt-4 text-center">
          <button
            onClick={handleResend}
            disabled={resending}
            className="text-blue-600 hover:underline disabled:opacity-60"
          >
            {resending ? 'Resending...' : 'Resend OTP'}
          </button>
          {resendMessage && (
            <p className="text-sm mt-2 text-green-600">{resendMessage}</p>
          )}
        </div>

        {message && (
          <p
            className={`mt-4 text-center ${
              message.toLowerCase().includes('success')
                ? 'text-green-600'
                : 'text-red-600'
            }`}
          >
            {message}
          </p>
        )}
      </div>
    </div>
  );
};

// ✅ Inline SVG eye icons (consistent with Login & Signup)
function EyeIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
      />
    </svg>
  );
}

function EyeOffIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.542 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"
      />
    </svg>
  );
}

export default ResetPasswordWithOtp;